import React from 'react'
import { ContactUsForm } from '../../Contactus'

const Mailer = () => {
    return (
        <section className="w-full bg-gradient-radial py-12 lg:py-15">
            <div className="container mx-auto px-4 lg:px-15 text-center">
                <h2 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold font-inter text-white opacity-90">
                    Get In Touch
                </h2>
                <p className="mt-2 text-base sm:text-lg lg:text-xl font-medium font-inter text-white opacity-70">
                    Reach out, and let's create a universe of possibilities together!
                </p>
                <div className="flex flex-col items-center">
                    <div
                        className="w-[100%] md:w-[80%] mt-8 p-4 sm:p-8 lg:p-10 bg-white/5 rounded-[20px] backdrop-blur-lg border border-slate-950/5">
                        <div className="flex flex-col items-center">
                            <div className="w-[100%] md:w-[72%] flex flex-col gap-4">

                                <ContactUsForm
                                    isHideLabel={true}
                                    inputClass="bg-white/5 rounded-md font-normal text-md placeholder-white/60 p-3 font-inter"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Mailer